import {Box} from '@mui/material';
import React, {FC} from 'react';

export const FlexRow: FC<BoxProps> = React.memo((props) => {
  return (
    <Box display="flex" flexDirection="row" ref={props.boxref} {...props} >
      {props.children}
    </Box>
  );
});
